import React from "react";

import Button from "../../../../components/bases/button/button";
import Tooltip from "../../../../components/bases/tooltips/tooltip.js";

import {apiGetShortUserList, apiWriteUserDatas, apiCreateUserDatas} from "../../../../utils/apis.js"

import back from "./assets/icons/back.png"
import valider from "./assets/icons/valider.png"
import { GlobalContext } from '../../../../utils/globalprovider';
import { getCurrentUserDatas } from "../../../../utils/software";
import getText from "../../../../utils/language.js"


import './styles.css';




class LoginEditUser extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)
        
        this.state = {
            usersList : [],
            firstname: "",
            lastname: "",
            email: "",
            phone: "",

            mdp1:"",
            mdp2:"",
            image: null,

        }
        this.onfinish = this.onfinish.bind(this);
        this.getUsersDone = this.getUsersDone.bind(this);

        this.handleCancel = this.handleCancel.bind(this)
        this.handleValide = this.handleValide.bind(this)
        this.onUpdateUser = this.onUpdateUser.bind(this)
        this.onCreateUser = this.onCreateUser.bind(this)

        this.fisrtnameInput = React.createRef();
        this.lastnameInput = React.createRef();
        this.emailInput = React.createRef();
        this.phoneInput = React.createRef();
        this.mdp1Input = React.createRef();
        this.mdp2Input = React.createRef();
        this.iconInput = React.createRef();


    }

    onfinish()
    {
        
        this.props.onfinish(null)
    }


    handleKeyDown(event)
    {
        event.stopImmediatePropagation();


    }

    componentWillUnmount()
    {
        if (!this.props.create && this.props.userId === 0) this.props.onCancelKeyboardEvent (false);
    }
    componentDidMount()
    {


        if (!this.props.create && this.props.userId === 0) this.props.onCancelKeyboardEvent (true);
        this.getUsers();
    }




    render()
    {

        var txtmesinfos  = getText(10,0, this.context.language);
        if (this.props.userId != 0)
            txtmesinfos = this.context.language=="fr"?"Modifier un utilisateur":"Edit User"
        if (this.props.create )
            txtmesinfos = this.context.language=="fr"?"Créer un utilisateur":"Create User"

        const txtnom  = getText(10,1, this.context.language);
        const txtprenom  = getText(10,2, this.context.language);
        const txtmail  = getText(10,3, this.context.language);
        const txttel  = getText(10,4, this.context.language);
        const txtpass1  = getText(10,5, this.context.language);
        const txtpass2  = getText(10,6, this.context.language);
        const txtimage  = getText(10,7, this.context.language);
        const txtcancel  = getText(10,8, this.context.language);
        const txtvalide  = getText(10,9, this.context.language);



        
        
        return (
            <>
            <div className="modal-edit-darkBG"/>
            <div className="modal-edit-centered">
                <div className="modal-edit-modal">
                <div className="modal-edit-modalHeader">
                    <h5 className="modal-edit-heading">{txtmesinfos}</h5>
                </div>
                <button className="modal-edit-closeBtn" onClick={this.onfinish}>
                    x
                </button>
                <div className="modal-edit-modalContent" >





                    <label className="modal-edit-formUser-label">
                        {txtnom}
                        <input className="modal-edit-formUser-input" autoFocus={true}
                        name="lastname"
                        ref={this.lastnameInput}
                        type="text"
                        id = "userlasttname"
                        autoComplete="off"
                        onChange={e => this.setState({lastname:e.target.value})}
                        value={this.state.lastname}
                        required />
                    </label>

                    <label className="modal-edit-formUser-label">
                        {txtprenom}
                        <input className="modal-edit-formUser-input"
                        name="firstname"
                        id = "userfirstname"
                        type="text"
                        autoComplete="off"
                        ref={this.firstnameInput}
                        onChange={e => this.setState({firstname:e.target.value})}
                        value={this.state.firstname}
                        required />
                    </label>

                    <label className="modal-edit-formUser-label">
                        {txtmail}
                        <input className="modal-edit-formUser-input"
                        name="email"
                        type="text"
                        id = "usermail"
                        autoComplete="off"
                        ref={this.emailInput}
                        onChange={e => {
                            this.setState({email:e.target.value});
                            this.checkmail();
                                }
                            }
                        value={this.state.email}
                        required />
                    </label>
                    <label className="modal-edit-formUser-label">
                        {txttel}
                        <input className="modal-edit-formUser-input"
                        name="phone"
                        type="text"
                        autoComplete="off"
                        ref={this.phoneInput}
                        onChange={e => this.setState({phone:e.target.value})}
                        id = "userphone"
                        value={this.state.phone}
                        />
                    </label>

                    <label className="modal-edit-formUser-label">
                        {txtpass1}
                        <input className="modal-edit-formUser-input"
                        name="mdp1"
                        type="password"
                        autoComplete="new-password"
                        ref={this.mdp1Input}
                        id = "userpwd1"
                        onChange={e => this.setState({mdp1:e.target.value})}
                        onFocus= {this.focusonpassword.bind(this)}
                        value={this.state.mdp1}
                        required />
                    </label>


                    <label className="modal-edit-formUser-label">
                        {txtpass2}
                        <input className="modal-edit-formUser-input"
                        name="mdp2"
                        type="password"
                        ref={this.mdp2Input}
                        id = "userpwd2"
                        onChange={e => this.setState({mdp2:e.target.value})}
                        onFocus= {this.focusonpassword.bind(this)}
                        value={this.state.mdp2}
                        autoComplete="new-password"
                        required />
                    </label>


                    <label className="modal-edit-formUser-label">
                        {txtimage}
                        <input className="modal-edit-formUser-input"


                        name="icon"
                        type="file"
                        ref={this.iconInput}

                        onChange={e=> this.onimageloaded(e)}
                        id = "userimage"
                        
                        required />
                    </label>
                    <img className = "modal-edit-formUser-icon"
                        ref={this.iconImage}
                        src={this.state.image}
                    />


                    <table className="modal-edit-formUser-tablebutton"><tbody>
                    <tr>
                    <td width="3%">&nbsp;</td>
                    <td width="60%" className="formUser-errormsg">{this.state.errorMsg}&nbsp;</td>
                    <td width="20%">
                    <span>
                    <Tooltip text={txtcancel}>
                    <Button 
                        width="48" height="48" 
                        image={back} 
                        disable={false}
                        buttonName="bback"
                        onClick={this.handleCancel}
                    />
                    </Tooltip>
                    </span>
                    </td><td width="12%">
                    <span>
                    <Tooltip text={txtvalide}>
                    <Button 
                    width="48" height="48" 
                    image={valider} 
                    disable={false}
                    buttonName="bvalide"
                    onClick={this.handleValide}
                    />
                    </Tooltip>
                    </span>
                    </td>
                    <td width="5%"></td></tr>
                    </tbody></table>







                </div>
                
                </div>
            </div>
            </>      
    

        )
    }



    getUsers()
    {
        apiGetShortUserList(this.getUsersDone);
    }


    getUsersDone(datas)
    {
        
        var lastname=""
        var firstname=""
        var email=""
        var image=""
        var id=0;
        var phone="";
        var mdp1="";
        var mdp2="";

        


        if (!this.props.create)
        {


            if (this.props.userId !== 0) 
            {
                datas.forEach(user => {
                    if (user.id === this.props.userId)
                    {
                        id= user.id;
                        lastname= user.lastname;
                        firstname= user.firstname;
                        email= user.email;
                        image= user.image ;
                        phone= user.phone;
                        
                    }
                    
                });
            }
            else
            {            
                
                try{
                    
                    var userData = getCurrentUserDatas().datas;
                    id= userData.id;
                    lastname= userData.lastname;
                    firstname= userData.firstname;
                    email= userData.email;
                    image= userData.image ;
                    phone= userData.phone;

                    

                }
                catch(e)
                {
                    
                    id=0;
                }
            }
        }

        this.setState  ({

            firstname: firstname,
            lastname: lastname,
            email: email,
            phone: phone,

            mdp1:this.props.create?mdp1:"password1",
            mdp2:this.props.create?mdp2:"password2",
            image: image,
            id: id,
     
            usersList : datas,
            firstChangePassword: !this.props.create,
            errorMsg: "",

        }
        
    )
        
        
    }


    focusonpassword()
    {
        
        if (this.state.firstChangePassword)
        {
            this.setState({
                firstChangePassword: false,
                mdp1: "",
                mdp2: "",
            })
        }
    }
    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file)
          fileReader.onload = () => {
            resolve(fileReader.result);
          }
          fileReader.onerror = (error) => {
            reject(error);
          }
        })
      }

    onimageloaded = async (event) => {
        const file = event.target.files[0]
        const base64 = await this.convertBase64(file)
        
        this.setState ( {image : base64})
        
        }

    checkvalidemail()
    {
        var cmail = this.emailInput.current.value
        if (!cmail.match(/[a-z0-9_\-\.]+@[a-z0-9_\-\.]+\.[a-z]+/i)) {
            return false;
        }        
        return true;
    }

    checkmail()
    {
        
        var currentid = this.state.id;
        var cmail = this.emailInput.current.value
        
        var errMSG = ""
        for(var i=0; (i< this.state.usersList.length) && (errMSG == ""); i++)
        {
            var email = this.state.usersList[i].email
            var id = this.state.usersList[i].id
            
            if ((email.toLowerCase() == cmail.toLowerCase()) &&  (id != currentid))
            {
                    errMSG="Mail déja utilisé."
                    
            }
        }

        if (this.state.errorMsg != errMSG)
            this.setState({errorMsg: errMSG})

        return errMSG;

    }
    
    handleValide(event)
    {
    

        const txtrequired  = getText(10,10, this.context.language);
        const txtused = getText(10,11, this.context.language);
        const txtbadformat  = getText(10,12, this.context.language);
        const txtshort  = getText(10,13, this.context.language);
        const txtsame  = getText(10,14, this.context.language);
   
        this.setState({errorMsg:""})
        if (this.state.firstname.trim()=="")  { this.fisrtnameInput.current.focus();
            this.setState({errorMsg:txtrequired})
                return;}
        if (this.state.lastname.trim()=="")  { this.lastnameInput.current.focus();
            this.setState({errorMsg:txtrequired})
            return;}
        if (this.state.email.trim()=="")  { this.emailInput.current.focus();
            this.setState({errorMsg:txtrequired})
            return;}


        if (this.checkmail() != "")
        {
            this.setState({errorMsg:txtused})
            this.emailInput.current.focus();
            return;
        }

        if (!this.checkvalidemail())
        {
            this.setState({errorMsg:txtbadformat})
            this.emailInput.current.focus();
            return;

        }

       


        var mdp = this.state.mdp1;
        if ((this.state.firstChangePassword == false) && this.mdp1Input.current &&  this.mdp2Input.current)
        {
            if (this.state.mdp1.trim().length<8)  { this.mdp1Input.current.focus();
                this.setState({errorMsg: (<span>{txtshort}</span>)})
                    return;}
        
            if (this.state.mdp2 != this.state.mdp1)  { this.mdp2Input.current.focus();
                this.setState({errorMsg: (<span>{txtsame}</span>)})
                    return;}
                
                
        }
        else
            mdp="";

        var image = this.state.image;
        if ((image == null) || (image.length <5))
            image="";

            
        
        this.alldatasFinales =
        {
            "id": this.state.id,
            "firstname" : this.state.firstname,
            "lastname" : this.state.lastname,
            "email" : this.state.email,
            "phone" : this.state.phone,
            "password" : mdp,
            "image": image,
        }
        if (!this.props.create)
            apiWriteUserDatas (this.alldatasFinales, this.onUpdateUser);
        else
            apiCreateUserDatas (this.alldatasFinales, this.onCreateUser);
    
    }

    onCreateUser(datas)
    {
        if (this.props.onCreateUser) this.props.onCreateUser(datas.id)
    }
    onUpdateUser()
    {
        
        this.props.onfinish(this.alldatasFinales);
    }

    handleCancel(event)
    {
        
        this.props.onfinish(null);
    }


}

LoginEditUser.defaultProps =
{
    userId:0,
    create: false,
}

export default LoginEditUser

